export enum Chain {
  Eth = 'eth',
  Sol = 'sol'
}
